import { BackendFormResponse, ibmClientId, individualRatesApi, retrieveNewQuotesApi } from '../util/api';
import { RateQuoteFormData, transformDataForApi } from '../util/form';
import { getEmailPlans } from './emailData';

export async function submitInputs(data: RateQuoteFormData, embeddedAgent = false): Promise<BackendFormResponse> {
    const isEmbeddedApi = !!data.pnumber && !embeddedAgent; // Determine if the request is for the embedded API
    const apiUrl = isEmbeddedApi  ? retrieveNewQuotesApi : individualRatesApi; // Select the appropriate API URL
    const headers: Record<string, string> = isEmbeddedApi
        ? { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' }
        : { 'Content-Type': 'application/json', 'X-IBM-Client-ID': ibmClientId || '' };

    // Transform data based on the API type
    const dataForApi = transformDataForApi(data, isEmbeddedApi);

    // Prepare the request body
    const body = isEmbeddedApi
        ? (dataForApi as URLSearchParams).toString() // URL-encoded string for embedded API
        : JSON.stringify(dataForApi); // JSON string for standard API

    // Make the API request
    const res = await fetch(apiUrl, {
        method: 'POST',
        headers,
        body,
    });

    if (isEmbeddedApi) {
        const responseBody = await res.json(); // Parse the response body as JSON
        if (!responseBody.quoteId) {
            throw new Error('quoteId is missing in the response');
        }
        const quoteId: string = responseBody.quoteId; // Access quoteId from the parsed response
        sessionStorage.setItem('embeddedQuoteId', quoteId);
        const emailPlansResponse = await getEmailPlans(quoteId);
        return emailPlansResponse;
    }

    // Handle errors
    if (!res.ok) {
        throw new Error(`Error getting input response for ${JSON.stringify(res)}. ${res.statusText}`);
    }

    // Parse and return the response
    return res.json();
}
